// extracted by mini-css-extract-plugin
module.exports = {"content":"IconTextView_content__y_5yI","icon":"IconTextView_icon__2FaBZ","text":"IconTextView_text__2-yUK"};